import { useQuery } from '@tanstack/react-query';
import { BASE_API_URL } from '../consts/base-url';
import type { User } from '../types/user';
import customFetch from '../utils/fetch';
export const useGetUsers = (pageNumber: number, pageSize = 100) => {
  const {
    data,
    isLoading,
    isError,
    error
  } = useQuery({
    queryKey: ['getUsers', pageNumber, pageSize],
    queryFn: async () => {
      const response = await customFetch(`${BASE_API_URL}/user?pageNumber=${pageNumber}&pageSize=${pageSize}`, {});
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to fetch users');
      }
      const {
        data,
        page,
        totalPages
      } = (await response.json() as {
        data: User[];
        page: number;
        totalPages: number;
      });
      return {
        users: data,
        totalPages,
        page
      };
    },
    retry: false
  });
  return {
    data,
    isLoading,
    isError,
    error
  };
};